var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgList24DpE3E3E3Fill0Wght400Grad0Opsz24 = function SvgList24DpE3E3E3Fill0Wght400Grad0Opsz24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e3e3e3",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280-600v-80h560v80zm0 160v-80h560v80zm0 160v-80h560v80zM160-600q-17 0-28.5-11.5T120-640t11.5-28.5T160-680t28.5 11.5T200-640t-11.5 28.5T160-600m0 160q-17 0-28.5-11.5T120-480t11.5-28.5T160-520t28.5 11.5T200-480t-11.5 28.5T160-440m0 160q-17 0-28.5-11.5T120-320t11.5-28.5T160-360t28.5 11.5T200-320t-11.5 28.5T160-280"
  })));
};
export default SvgList24DpE3E3E3Fill0Wght400Grad0Opsz24;